import React, { Component } from 'react';
import { connect } from 'react-redux';
import './Header.scss';

import AnchorLink from 'react-anchor-link-smooth-scroll';

class Header extends Component {
  
  render() {
    return (
      <div>
        <div className="mobile-menu">
          <ul className="d-flex flex-column">
            <li><AnchorLink href='#'><span>01</span> Home</AnchorLink></li>
            <li><AnchorLink offset='100' href='#below-banner'><span>02</span> About</AnchorLink></li>
            <li><AnchorLink offset='100' href='#our-process'><span>03</span> Process</AnchorLink></li>
            <li><AnchorLink offset='100' href='#we-have-worked-with'><span>04</span> Our Customers</AnchorLink></li>
          </ul>

          <div className="close-btn">
            <i className="fal fa-times"></i>
          </div>
        </div>
        <section id="top-header-bar">
          <div className="container-fluid">
            <div className="row justify-content-between align-items-center">
              <div className="social-icons">
                <ul className="d-flex align-items-center">
                  <li><a href="https://www.facebook.com/pixel8agency/?ref=whp" target="_blank"><i className="fab fa-facebook-f"></i></a></li>
                  {/* <li><a href="#"><i className="fab fa-instagram"></i></a></li> */}
                  <li><a href="https://twitter.com/pixel8agency?ref=whp" target="_blank"><i className="fab fa-twitter"></i></a></li>
                </ul>
              </div>
              <div className="right-buttons d-flex align-items-stretch">
                <a href="#" className="customer-portal-link">Customer Portal <span className="coming-soon-small">(Coming Soon)</span></a>
                <a href="mailto:jonathon@pixel8.io?Subject=Lets%20work%20together" className="get-in-touch-link"><i className="far fa-envelope"></i> Get In Touch</a>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

export default connect()(Header);



// WEBPACK FOOTER //
// ./src/components/Common/Header/Header.js